export const initialState = {
  activitiesList: [],
  lockedActivitiesList: [],
  unlockedActivitiesList: [],
  readingList: [],
  activeActivityQuestionsList: [],
  has_next: true,
  next_page: 1,
  offset: 0,
  prev_page: 0,
  loading: false,
  loadingActivities: false,
};
